import React, {useEffect} from 'react';
import {SideSheetMuseumFilter} from "./SideSheetMuseumFilter";
import {ModalMuseumFilter} from "./ModalMuseumFilter";
import {kitFetch} from "@ekultur/fetch";
import {SET_MUSEUMS, SET_PARENTS, useMuseumFilterDispatch, useMuseumFilterState} from "./museumFilterContext";
import camelize from 'camelize';
import {SideSheetContent} from './SideSheetContent';
import {useMediaQuery, Box, useTheme} from "@mui/material";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        flexDirection: "row",
        height: "100vh",
        width: "100%",
    }
}))

const viewMode = (smUp, forceMobil, forceDesktop) => {
    if(forceMobil) {
        return "mobile";
    } else if (forceDesktop) {
        return "desktop";
    } else {
        return smUp ? "desktop" : "mobile";
    }
}

export const WithMuseumSideSheet = ({forceMobile=false, forceDesktop=false, children}) => {
    const classes = useStyles();
    const theme = useTheme();
    const smUp = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useMuseumFilterDispatch();
    const {
        includeIds,
    } = useMuseumFilterState();

    if(!window._env_) {
        window._env_ = {
            REACT_APP_API_GATEWAY: 'https://beta-apigateway.dimu.org'
        }
    } else if(!window._env_.REACT_APP_API_GATEWAY) {
        window._env_ = {
            ...window.env,
            REACT_APP_API_GATEWAY: 'https://beta-apigateway.dimu.org'
        }
    }

    useEffect(() => {
        kitFetch(`/museum-api/museums/*/children/`)
            .then(json => dispatch({
                type: SET_PARENTS,
                parents: json
            }))
        kitFetch(`/museum-api/museums`)
            .then(json => dispatch({
                type: SET_MUSEUMS,
                museums: camelize(json.museums)
            }))
    }, [JSON.stringify(includeIds)])

    const view = {
        "mobile": (
            <ModalMuseumFilter>
                <SideSheetContent />
            </ModalMuseumFilter>
        ),
        "desktop": (
            <SideSheetMuseumFilter>
                <SideSheetContent />
            </SideSheetMuseumFilter>
        )
    }


    return (
        <div className={classes.root}>
            <Box flexGrow={1}>
                {children}
            </Box>
            {view[viewMode(smUp, forceMobile, forceDesktop)]}
        </div>
    )
}